// Campaign configuration for Swapper Portal
// This is a whitelabel solution with a single active campaign

export const CAMPAIGN_ID = "swapper-portal";
export const CAMPAIGN_GROUP_ID = "1";

export const CAMPAIGN_CONFIG = {
  id: CAMPAIGN_ID,
  groupId: CAMPAIGN_GROUP_ID,
} as const;
